import { BlogPost, RelatedPosts } from 'components/Blog'
import { Footer } from 'components/Footer'
import { Header } from 'components/Header'
import { SeoFooter } from 'components/SeoFooter'
import { useBlogPostsBySlugQuery } from 'hooks/useBlogPostsBySlugQuery'
import { NextPage } from 'next'
import { NextSeo } from 'next-seo'
import { useRouter } from 'next/router'
import { useIntl } from 'react-intl'

const BlogPostPage: NextPage = () => {
  const { query } = useRouter()
  const { formatMessage } = useIntl()

  const { data } = useBlogPostsBySlugQuery({
    variables: { slug: query.postSlug },
  })

  const post = data?.blogPostsBySlug.posts[0]

  return (
    <>
      <NextSeo
        title={formatMessage({ id: 'blog.post.meta.title' }, { title: post?.title })}
        description={post?.excerpt}
      />
      <Header bordered={false} />
      {post && <BlogPost post={post} />}
      <RelatedPosts />
      <SeoFooter />
      <Footer />
    </>
  )
}

export default BlogPostPage
